import { render, staticRenderFns } from "./InformesForm.vue?vue&type=template&id=2f18a650"
import script from "./InformesForm.vue?vue&type=script&lang=ts"
export * from "./InformesForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports